import React from 'react';
import { TextInput } from 'react-native-web';
import PropTypes from 'prop-types';

/* Expansion of native-base <Input /> component */

const propTypes = {
  isSecureText: PropTypes.bool,
};

const defaultProps = {
  isSecureText: false,
};

// TODO: Add back secure text toggle/state handler
const Input = ({ isSecureText, ...rest }) => {
  const fieldType = isSecureText ? 'password' : 'text';

  return (
    <TextInput
      flex={1}
      type={fieldType}
      autoCapitalize={isSecureText ? 'none' : 'sentences'}
      {...rest}
    />
  );
};

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

export default Input;
